var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('appButton',{staticClass:"btn",on:{"click":function($event){return _vm.downloadExcel()}}},[_vm._v("Hent resultat som Excel")])}
var staticRenderFns = []

export { render, staticRenderFns }